var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDropzone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M25 35.75C25.4142 35.75 25.75 35.4142 25.75 35C25.75 34.5858 25.4142 34.25 25 34.25V35.75ZM5 28.3333V27.5833C4.58579 27.5833 4.25 27.9191 4.25 28.3333H5ZM21.6667 28.3333H22.4167C22.4167 27.9191 22.0809 27.5833 21.6667 27.5833V28.3333ZM28.3333 10.9167C27.9191 10.9167 27.5833 11.2525 27.5833 11.6667C27.5833 12.0809 27.9191 12.4167 28.3333 12.4167V10.9167ZM31.6667 5.75C32.0809 5.75 32.4167 5.41421 32.4167 5C32.4167 4.58579 32.0809 4.25 31.6667 4.25V5.75ZM7.58333 28.3333C7.58333 28.7475 7.91912 29.0833 8.33333 29.0833C8.74755 29.0833 9.08333 28.7475 9.08333 28.3333H7.58333ZM25 34.25H10V35.75H25V34.25ZM10 34.25C7.65279 34.25 5.75 32.3472 5.75 30H4.25C4.25 33.1756 6.82436 35.75 10 35.75V34.25ZM5.75 30V28.3333H4.25V30H5.75ZM5 29.0833H21.6667V27.5833H5V29.0833ZM20.9167 28.3333V31.6667H22.4167V28.3333H20.9167ZM20.9167 31.6667C20.9167 33.9218 22.7448 35.75 25 35.75V34.25C23.5733 34.25 22.4167 33.0934 22.4167 31.6667H20.9167ZM25 35.75C27.2552 35.75 29.0833 33.9218 29.0833 31.6667H27.5833C27.5833 33.0934 26.4267 34.25 25 34.25V35.75ZM29.0833 31.6667V8.33333H27.5833V31.6667H29.0833ZM29.0833 8.33333C29.0833 6.9066 30.2399 5.75 31.6667 5.75V4.25C29.4115 4.25 27.5833 6.07817 27.5833 8.33333H29.0833ZM31.6667 5.75C33.0934 5.75 34.25 6.9066 34.25 8.33333H35.75C35.75 6.07817 33.9218 4.25 31.6667 4.25V5.75ZM34.25 8.33333C34.25 9.76007 33.0934 10.9167 31.6667 10.9167V12.4167C33.9218 12.4167 35.75 10.5885 35.75 8.33333H34.25ZM31.6667 10.9167H28.3333V12.4167H31.6667V10.9167ZM31.6667 4.25H13.3333V5.75H31.6667V4.25ZM13.3333 4.25C10.1577 4.25 7.58333 6.82436 7.58333 10H9.08333C9.08333 7.65279 10.9861 5.75 13.3333 5.75V4.25ZM7.58333 10V28.3333H9.08333V10H7.58333Z",
    fill: "#848A9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15 11.6666H21.6667",
    stroke: "#848A9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M15 18.3333H21.6667",
    stroke: "#848A9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDropzone);
export default __webpack_public_path__ + "static/media/documentDropzone.876519e3b946c4bc80fc67e11431c3a3.svg";
export { ForwardRef as ReactComponent };